import { ID } from './id';
import { TaskPriorityOptions, TaskType } from './task-base';
import { Timestamp } from './timestamp';

export enum QueryFilterOptionKeys {
  LifeAreas = 'lifeAreas',
  Goals = 'goals',
  Ids = 'ids',
  TasksOnly = 'tasksOnly',
  ShowCompleted = 'showCompleted',
  DeadlineDeadlineStartDate = 'deadlineDeadlineStartDate',
  DeadlineDeadlineEndDate = 'deadlineDeadlineEndDate',
  HasDeadlineDeadline = 'hasDeadlineDeadline',
  NoDeadlineDeadline = 'noDeadlineDeadline',
  DeadlineStartDate = 'deadlineStartDate',
  DeadlineEndDate = 'deadlineEndDate',
  HasDeadline = 'hasDeadline',
  NoDeadline = 'noDeadline',
  NoLifeArea = 'noLifeArea',
  NoGoal = 'noGoal',
  ParentIds = 'parentIds',
  NoParentIds = 'noParentIds',
  Deleted = 'deleted',
  CompletedStartDate = 'completedStartDate',
  CompletedEndDate = 'completedEndDate',
}

export type QueryFilterOptions = {
  [QueryFilterOptionKeys.LifeAreas]?: ID[];
  [QueryFilterOptionKeys.Goals]?: ID[];
  [QueryFilterOptionKeys.Ids]?: ID[];
  [QueryFilterOptionKeys.ShowCompleted]?: boolean;
  [QueryFilterOptionKeys.TasksOnly]?: boolean;
  [QueryFilterOptionKeys.DeadlineDeadlineStartDate]?: Timestamp; // timestamp in milliseconds
  [QueryFilterOptionKeys.DeadlineDeadlineEndDate]?: Timestamp; // timestamp in milliseconds
  [QueryFilterOptionKeys.HasDeadlineDeadline]?: boolean;
  [QueryFilterOptionKeys.NoDeadlineDeadline]?: boolean;
  [QueryFilterOptionKeys.DeadlineStartDate]?: Timestamp; // timestamp in milliseconds
  [QueryFilterOptionKeys.DeadlineEndDate]?: Timestamp; // timestamp in milliseconds
  [QueryFilterOptionKeys.HasDeadline]?: boolean;
  [QueryFilterOptionKeys.NoDeadline]?: boolean;
  [QueryFilterOptionKeys.NoLifeArea]?: boolean;
  [QueryFilterOptionKeys.NoGoal]?: boolean;
  [QueryFilterOptionKeys.ParentIds]?: ID[];
  [QueryFilterOptionKeys.NoParentIds]?: boolean;
  [QueryFilterOptionKeys.Deleted]?: boolean;
  [QueryFilterOptionKeys.CompletedStartDate]?: Timestamp; // timestamp in milliseconds
  [QueryFilterOptionKeys.CompletedEndDate]?: Timestamp; // timestamp in milliseconds
};

export type TaskFilterOptions = QueryFilterOptions & {
  types?: TaskType[];
  priorities?: TaskPriorityOptions[];
  minDuration?: number; // in milliseconds (from "more than" filter)
  maxDuration?: number; // in milliseconds (from "less than" filter)
  excludeIds?: ID[];
  includeTaskWithAction?: boolean;
  excludeHiddenTodoHabits?: boolean;
  archivedGoalIds?: ID[];
  includeArchived?: boolean;
  deleted?: boolean;
  sortingMode?: string;
};
